<div class="create-student">
    <h3>Create Student</h3>
    <mat-dialog-content class="mat-typography">
    <form [formGroup]="myForm" >
<mat-form-field appearance="fill">
    <mat-label>Name</mat-label>
    <input formControlName="Name" matInput>    
  </mat-form-field>
  <div *ngIf="this.myForm.get('Name').invalid && (this.myForm.get('Name').dirty || this.myForm.get('Name').touched)">
    Please provide a name.
  </div>
  <mat-form-field appearance="fill">
    <mat-label >Age</mat-label>
    <input formControlName="Age" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Address</mat-label>
    <textarea  formControlName="Address" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Gender</mat-label>
    <textarea  formControlName="Gender" matInput></textarea>
  </mat-form-field>
  <!-- <mat-form-field appearance="fill">
    <mat-label>Choose a date</mat-label>
    <input  matInput [matDatepicker]="picker" formControlName="Dateofbirth">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker  #picker></mat-datepicker>
  </mat-form-field> -->
  <mat-form-field appearance="fill">
    <mat-label>Dateofbirth</mat-label>
    <textarea  formControlName="Dateofbirth" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Class</mat-label>
    <textarea  formControlName="Classname" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Section</mat-label>
    <textarea  formControlName="Sectionname" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Religion</mat-label>
    <textarea  formControlName="Religion" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Caste</mat-label>
    <textarea  formControlName="Caste" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Mobile</mat-label>
    <textarea  formControlName="Mobile" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Admission No</mat-label>
    <textarea  formControlName="Admissionnum" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Father Name</mat-label>
    <textarea  formControlName="Fathername" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Father Occupation No</mat-label>
    <textarea  formControlName="Fatheroccu" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Mother Name</mat-label>
    <textarea  formControlName="Mothername" matInput></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Mother Occupation No</mat-label>
    <textarea  formControlName="Motheroccu" matInput></textarea>
  </mat-form-field>
 
 
 
 
  <!-- <button type="submit" mat-button cdkFocusInitial>Save</button> -->
    </form>
  </mat-dialog-content>
     <div mat-dialog-actions>
    <button mat-raised-button color="warn" (click)="onNoClick()">Close</button>
    <button  mat-raised-button [mat-dialog-close]  color="primary" (click)="onSubmit()" [disabled]="myForm.invalid">{{this.actionName}}</button>
  </div>

</div>